import { render, staticRenderFns } from "./FormEnquiryIcon.vue?vue&type=template&id=809c8a00&"
import script from "./FormEnquiryIcon.vue?vue&type=script&lang=js&"
export * from "./FormEnquiryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports